"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseInternetAccountConfig = void 0;
const configuration_1 = require("../../configuration");
exports.BaseInternetAccountConfig = (0, configuration_1.ConfigurationSchema)('InternetAccount', {
    name: {
        description: 'descriptive name of the internet account',
        type: 'string',
        defaultValue: '',
    },
    description: {
        description: 'a description of the internet account',
        type: 'string',
        defaultValue: '',
    },
    authHeader: {
        description: 'request header for credentials',
        type: 'string',
        defaultValue: 'Authorization',
    },
    tokenType: {
        description: 'a custom name for a token to include in the header',
        type: 'string',
        defaultValue: '',
    },
    domains: {
        description: 'array of valid domains the url can contain to use this account',
        type: 'stringArray',
        defaultValue: [],
    },
}, { explicitIdentifier: 'internetAccountId', explicitlyTyped: true });
